/**
 * Returns true of the input value is null, undefined, or an empty string
 */
export function isBlank<T extends string | number = string>(
  input: T | null | undefined
): input is undefined | null {
  if (typeof input == "undefined") {
    return true;
  }
  if (input == null) {
    return true;
  }
  if (typeof input === "number") {
    return false;
  }
  if (input.length == 0) {
    return true;
  }
  if (/^\s*$/.test(input)) {
    return true;
  }
  return false;
}
